import React from "react";

import "../Styles/LoaderStyles.css";

const Loader = (props) => {
    return (
        <div class="loader-container">
            <div class="wave-container">
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
            </div>
            <div class="text">PROCESSING</div>
        </div>
    );
}

export default Loader;

